// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"376":"b66a73bb","685":"10e362ab"}[chunkId] + ".chunk.css";
};